import { HttpService } from "../../../utils/DesigningHttpService.js";
import { agencyBootstrap } from "./agencyIdentityService.ts";

const http = new HttpService();

export type RegistrationOptions = {
  allowSelfRegistration: boolean;
  provinces: { id: number; name: string; cities: { id: number; name: string }[] }[];
};

export type RegistrationValues = {
  firstName: string;
  lastName: string;
  mobile: string;
  provinceId: number;
  cityId: number;
  address: string;
  description?: string;
  languageCode: "fa" | "en" | "ar";
  password: string;
  passwordConfirmation: string;
};

export async function registrationOptions(): Promise<RegistrationOptions> {
  return http.getAnonymousResource("/catalog/agency-registration");
}

export async function registerAgency(values: RegistrationValues): Promise<void> {
  const bootstrap = await agencyBootstrap();
  await http.postasync("/catalog/agency-registration", values, {
    headers: { "X-Portal-Csrf": bootstrap.csrfToken },
  });
}
